import styled from "styled-components";
import StandardButton from "common/components/styled-components/StandardButton";

export default styled(StandardButton)`
  width: 150px;
  height: 45px;
  padding: 0;
  margin: 0;
  margin-left: auto;
  font-size: 16px;
  flex: initial;
`;
